import { render, staticRenderFns } from "./EditarImagenDerivada.vue?vue&type=template&id=55754e4e"
import script from "./EditarImagenDerivada.vue?vue&type=script&lang=js"
export * from "./EditarImagenDerivada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports